import React from 'react';
import { TestimonialCard } from '../cards';

const Testimonials: React.FC = () => {
  return (
    <>
      {/* Desktop Testimonials - exact Figma layout */}
      <section className="hidden desktop:block bg-background-default w-full">
        <div className="w-device-desktop mx-auto p-1600 flex flex-col gap-1200 items-start">
          {/* Text Content Heading */}
          <div className="flex flex-col gap-200 items-start">
            <p className="text-[24px] font-semibold text-text-default leading-[1.2] tracking-[-0.48px] w-full whitespace-pre-wrap">
              Heading
            </p>
            <div className="flex flex-col justify-center leading-[0] w-full">
              <p className="text-[20px] font-regular text-text-secondary leading-[1.2] whitespace-pre-wrap">
                Subheading
              </p>
            </div>
          </div>
          
          {/* Card Grid - 3 columns */}
          <div className="flex flex-wrap gap-1200 items-start w-full">
            <TestimonialCard className="flex-1" />
            <TestimonialCard className="flex-1" />
            <TestimonialCard className="flex-1" />
            <TestimonialCard className="flex-1" />
            <TestimonialCard className="flex-1" />
            <TestimonialCard className="flex-1" />
          </div>
        </div>
      </section>

      {/* Mobile Testimonials - exact Figma layout */}
      <section className="block desktop:hidden bg-background-default w-full">
        <div className="p-600 flex flex-col gap-1200 items-start">
          {/* Text Content Heading */}
          <div className="flex flex-col gap-200 items-start">
            <p className="text-[24px] font-semibold text-text-default leading-[1.2] tracking-[-0.48px] w-full whitespace-pre-wrap">
              Heading
            </p>
            <div className="flex flex-col justify-center leading-[0] w-full">
              <p className="text-[20px] font-regular text-text-secondary leading-[1.2] whitespace-pre-wrap">
                Subheading
              </p>
            </div>
          </div>
          
          {/* Card Grid - single column on mobile */}
          <div className="flex flex-wrap gap-600 items-start w-full">
            <TestimonialCard />
            <TestimonialCard />
            <TestimonialCard />
            <TestimonialCard />
            <TestimonialCard />
            <TestimonialCard />
          </div>
        </div>
      </section>
    </>
  );
};

export default Testimonials;

